module.exports = __webpack_public_path__ + "images/tips/board-basics@2x.6c6e25551467f9e8f08a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/board-basics@2x.png
// module id = GRXg
// module chunks = 1